import { render } from "./LandingPageReferralHistorySection.vue?vue&type=template&id=0a6fb0b8&scoped=true"
import script from "./LandingPageReferralHistorySection.vue?vue&type=script&lang=js"
export * from "./LandingPageReferralHistorySection.vue?vue&type=script&lang=js"

import "./LandingPageReferralHistorySection.vue?vue&type=style&index=0&id=0a6fb0b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6fb0b8"]])

export default __exports__